import React from "react"
import { Link } from "gatsby"

const ButtonExternal = ({ data, display }) => {
  return (
    <Link
      target={"_blank"}
      rel={"noopener noreferrer"}
      className={`bg-edc-green py-2 px-4 border-2 rounded-3xl text-white cursor-pointer group ${
        display ? display : ""
      } hover:shadow-md hover:bg-white hover:text-edc-green border-edc-green min-w-[138px] md:min-w-[140px] text-center font-medium max-w-fit transition-all`}
      to={data.buttonUrl}
    >
      {data.buttonText}
    </Link>
  )
}

export default ButtonExternal
